function Text({translate, withURL}){

	return 	<div className="text-wrap"  >
				<h1 className="logo-text" dangerouslySetInnerHTML={{__html: translate('logo')}}>
				</h1>

			</div>
}

export default Text